/**
Copyright (C) 2019-2025, Infraclear Inc. All Rights Reserved.
*/

import instance from '../../../utils/axiosInstance';
import {
  AdminClients,
  AdminClientById,
} from '../../../constants/api-urlConstants';
import { Client, CreateClientPayload, UpdateClientPayload } from './types';

export const fetchClients = (): Promise<Client[]> => {
  return instance.get(AdminClients).then((response) => response.data.data ?? response.data);
};

export const fetchClientById = (clientId: number): Promise<Client> => {
  return instance.get(AdminClientById(clientId)).then((response) => response.data.data ?? response.data);
};

export const createClient = (payload: CreateClientPayload): Promise<Client> => {
  return instance.post(AdminClients, payload).then((response) => response.data.data ?? response.data);
};

export const updateClient = (payload: UpdateClientPayload): Promise<Client> => {
  return instance.put(AdminClients, payload).then((response) => response.data.data ?? response.data);
};

export const deactivateClient = (clientId: number): Promise<void> => {
  return instance.delete(AdminClientById(clientId)).then(() => undefined);
};
